// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2QvsY","containerItemsCenter":"Skeleton_containerItemsCenter__1p0hr"};